import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { DevicesClass } from '@app/core/classes';
import { Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { RoutingConfig } from '@app/routing/routing.config';
import { PrimeNGConfig } from 'primeng/api';

@UntilDestroy()
@Component({
  selector: 'app-create-artist-page-popup',
  templateUrl: 'create-artist-page-popup.component.html',
  styleUrls: ['create-artist-page-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateArtistPagePopupComponent extends DevicesClass implements OnInit {
  public Routing = RoutingConfig;

  constructor(
    injector: Injector,
    public cdr: ChangeDetectorRef,
    public ref: DynamicDialogRef,
    private router: Router,
    private primengConfig: PrimeNGConfig
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.primengConfig.ripple = true;
  }

  onCreateArtistPage($event: Event): void {
    $event.preventDefault();
    this.ref.close();
    this.router.navigateByUrl(
      `/${this.Routing.Account}/${this.Routing.AccountPerformers}/${this.Routing.Create}`
    ).catch();
  }

  onCloseDialog(): void {
    this.ref.close();
  }
}
